import { render, staticRenderFns } from "./payConfirm.vue?vue&type=template&id=56e138ae&scoped=true&"
import script from "./payConfirm.vue?vue&type=script&lang=js&"
export * from "./payConfirm.vue?vue&type=script&lang=js&"
import style0 from "./payConfirm.vue?vue&type=style&index=0&id=56e138ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e138ae",
  null
  
)

export default component.exports